// "Spot the Slip" expansion — BODY & HEALTH theme. Shape:
//   [ wrong, right, tag, why, slug ]

export const CORRECTIONS_BODY_HEALTH = [
  ["Mi amiga es enferma esta semana.", "Mi amiga está enferma esta semana.", "ser-estar",
    "Being ill is a temporary condition → estar.", "ser-vs-estar"],
  ["Después de correr, soy muy cansado.", "Después de correr, estoy muy cansado.", "ser-estar",
    "Tiredness right now is a passing state → estar.", "ser-vs-estar"],
  ["El médico es muy competente y amable.", "El médico es muy competente y amable.", "ser-estar",
    "Trap check: a defining professional quality correctly uses ser. (Already correct!)", "ser-vs-estar"],
  ["Me duele el rodilla derecha.", "Me duele la rodilla derecha.", "gender",
    "Rodilla is feminine → la rodilla.", "gender-agreement-of-nouns"],
  ["Tengo un tos muy fuerte.", "Tengo una tos muy fuerte.", "gender",
    "Tos is feminine → una tos.", "gender-agreement-of-nouns"],
  ["Tiene la garganta irritado.", "Tiene la garganta irritada.", "gender",
    "Irritada must agree with the feminine garganta.", "adjective-agreement"],
  ["Me duele las muelas por la noche.", "Me duelen las muelas por la noche.", "gustar",
    "Doler works like gustar; plural teeth → duelen.", "gustar-and-similar-verbs"],
  ["A mí me gusta los remedios naturales.", "A mí me gustan los remedios naturales.", "gustar",
    "Plural remedies liked → gustan.", "gustar-and-similar-verbs"],
  ["Tomé el jarabe para tres días.", "Tomé el jarabe por tres días.", "por-para",
    "Duration ('for a period of time') takes por.", "por-vs-para"],
  ["Estas pastillas son para el dolor de cabeza.", "Estas pastillas son para el dolor de cabeza.", "por-para",
    "Trap check: purpose ('intended for') correctly uses para. (Already correct!)", "por-vs-para"],
  ["¿La receta? El médico dio a mí ayer.", "¿La receta? El médico me la dio ayer.", "pronoun-order",
    "Combine indirect + direct: me + la → me la dio.", "object-pronouns"],
  ["El año pasado me rompía la pierna esquiando.", "El año pasado me rompí la pierna esquiando.", "preterito-imperfecto",
    "A single, finished injury takes the pretérito → me rompí.", "a2-preterito-vs-imperfecto"],
  ["Me duele mucho el estomago hoy.", "Me duele mucho el estómago hoy.", "accents",
    "Estómago is esdrújula, so it always carries a written accent.", "stress-and-written-accents"],
  ["Es importante que tú bebes más agua.", "Es importante que tú bebas más agua.", "subjunctive",
    "Impersonal 'es importante que' takes the subjunctive → bebas.", "b1-present-subjunctive"],
  ["El médico recomienda que descanso una semana.", "El médico recomienda que descanse una semana.", "subjunctive",
    "Recomendar que (advising) triggers the subjunctive → descanse.", "b1-present-subjunctive"],
];
